// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"99":"e021d584","200":"4276da8f","326":"934fb580","495":"303046f4","755":"58c2ad3b","927":"536f7ed2","970":"12e6df47"}[chunkId] + ".js";
};